import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import { EmployeeItem } from '../types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmployeeDetail: builder.query<EmployeeItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/Employee/${data.id}`,
      }),
    }),
    changeEmployee: builder.mutation<void, EmployeeItem>({
      query: (data) => ({
        url: `/v1/Employee/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createEmployee: builder.mutation<void, EmployeeItem>({
      query: (data) => ({
        url: '/v1/Employee',
        method: 'POST',
        body: data,
      }),
    }),
    deleteEmployee: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/Employee/${data.id}`,
        method: 'DELETE',
      }),
    }),
    historyEmployee: builder.query<any, PayloadRequest>({
      query: (data) => ({
        url: `/v1/Employee/${data.id}/history`,
      }),
    }),
  }),
});

export const {
  useChangeEmployeeMutation,
  useCreateEmployeeMutation,
  useDeleteEmployeeMutation,
  useGetEmployeeDetailQuery,
  useLazyGetEmployeeDetailQuery,
  useLazyHistoryEmployeeQuery,
} = request;
